import { useState } from "react";

import { typedQueryClient } from "hooks";
import { useGetWarrantyDashboardFilters } from "modules/WarrantyDashboard/hooks";
import { usePinHistoryQuery } from "modules/WarrantyDashboard/hooks/usePinHistoryQuery";
import { WarrantyQueryKeys } from "modules/WarrantyDashboard/queryKeys";

import type { Pin } from "models";

export const useWarrantyPinModal = () => {
  const [selectedPinForModal, setSelectedPinForModal] = useState<Pin | null>(null);

  const { filters } = useGetWarrantyDashboardFilters();
  const { data: pinHistory } = usePinHistoryQuery(selectedPinForModal, filters.deleted);
  const pinWithHistory = selectedPinForModal ? { ...selectedPinForModal, history: pinHistory ?? [] } : null;

  const handleOpenPinModal = (pinData: Pin) => setSelectedPinForModal(pinData);
  const handleClosePinModal = () => {
    typedQueryClient.setQueryData(WarrantyQueryKeys.pinHistory, []);
    setSelectedPinForModal(null);
  };

  return { pinWithHistory, handleClosePinModal, handleOpenPinModal };
};
